import { Card, CardContent, CardHeader, cn } from '@planuze/ui';
import type { LucideIcon } from 'lucide-react';

interface Props {
  readonly label: string;
  readonly value: string;
  readonly hint?: string;
  readonly icon: LucideIcon;
  /** Destaque destrutivo (ex.: SLA estourado — ADR-0463). */
  readonly highlight?: boolean;
}

/* Card de métrica composável (§4.18): rótulo + valor formatado + dica opcional. */
export function MetricCard({ label, value, hint, icon: Icon, highlight = false }: Props) {
  return (
    <Card className={cn(highlight && 'border-destructive/40')}>
      <CardHeader className="flex flex-row items-center justify-between pb-2">
        <span className="text-sm text-muted-foreground">{label}</span>
        <Icon
          className={cn('size-4 text-muted-foreground', highlight && 'text-destructive')}
          aria-hidden="true"
        />
      </CardHeader>
      <CardContent>
        <div
          className={cn('text-2xl font-semibold text-foreground', highlight && 'text-destructive')}
        >
          {value}
        </div>
        {hint !== undefined && <p className="mt-1 text-xs text-muted-foreground">{hint}</p>}
      </CardContent>
    </Card>
  );
}
